import { YAxisOptions } from "highcharts";
import {
  MIN_CPU_USAGE,
  MIN_DATABASE_CONNECTIONS,
  OffHoursRecommendationsChartColors,
} from "@/components/pages/recommendations/components/off-hours-recommendations/utils/constants/constants";

export const getYAxises = (
  withDbConnections: boolean,
  yAxisCpuTicks: number[],
  yAxisDbTicks: number[],
) => {
  const axis: YAxisOptions[] = [
    {
      title: { text: "" },
      tickPositions: yAxisCpuTicks,
      gridLineWidth: 1,
      gridLineDashStyle: "Dash",
      gridLineColor: "rgba(0, 0, 0, 0.3)",
      plotLines: [
        {
          value: MIN_CPU_USAGE,
          color: OffHoursRecommendationsChartColors.CpuLimitColor,
          width: 1,
        },
      ],
      labels: {
        formatter: function () {
          const value = +(this?.value ?? 0);

          const color =
            value <= MIN_CPU_USAGE
              ? OffHoursRecommendationsChartColors.CpuLimitColor
              : OffHoursRecommendationsChartColors.TextColor;
          return `<span style="fill: ${color}; color: ${color}">${value}</span>`;
        },
        useHTML: true,
        style: { fontSize: "8px" },
      },
    },
  ];

  if (withDbConnections) {
    axis.push({
      title: { text: "" },
      tickPositions: yAxisDbTicks,
      labels: { style: { fontSize: "8px" } },
      opposite: true,
      plotLines: [
        {
          width: 1,
          value: MIN_DATABASE_CONNECTIONS,
          color: OffHoursRecommendationsChartColors.DbConnectionsLimitColor,
        },
      ],
    });
  }

  return axis;
};
